import { render } from "./RegionalAirQuality.vue?vue&type=template&id=7ba3ba3a"
import script from "./RegionalAirQuality.vue?vue&type=script&lang=js"
export * from "./RegionalAirQuality.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__